export const textFieldDefaults = {
  variant: "outlined",
  size: "medium",
  fullWidth: true,
};

export const NUMBER_INPUT_DEFAULT_WIDTH = "100%";

export const formControlDefaults = {
  variant: "outlined",
  size: "medium",
};
